export default "__VITE_ASSET__92990962__"